/**
 * Configurator Persistence
 */

(function () {
  'use strict';

  var PARAM_VEHICLE           = 'cfg_v';
  var PARAM_GENERATION        = 'cfg_g';
  var PARAM_INSTALL_LOCATION  = 'cfg_il';
  var PARAM_OPTION_PREFIX     = 'cfg_o_';
  var PARAM_CART_KEY          = 'cfg_ck';

  var VEHICLE_SETTLE_MS = 200;
  var GEN_SETTLE_MS     = 150;

  var STORAGE_KEY      = 'sp_configurator_state';
  var EXPIRY_MS        = 4 * 60 * 60 * 1000;
  var SAVE_DEBOUNCE_MS = 300;

  var isRestoring = false;

  function isGenerationRequired() {
    var el = document.querySelector('.generation-selector');
    return !!el && !el.hidden && el.style.display !== 'none';
  }

  function readVehicle() {
    var btn = document.querySelector('#vehicle-model-list .disclosure__link[aria-selected="true"]');
    if (btn) {
      return {
        value:       btn.dataset.value        || '',
        label:       (btn.dataset.optionText || btn.textContent || '').trim(),
        vehicleSize: btn.dataset.vehicleSize   || '',
        odooSku:     btn.dataset.vehicleOdooSku || '',
      };
    }

    var triggerSpan = document.querySelector('#vehicle-model-selector .disclosure__button > span[data-label]');
    if (triggerSpan) {
      var label = (triggerSpan.dataset.optionText || triggerSpan.textContent || '').trim();
      var placeholder = (triggerSpan.getAttribute('data-label') || '').trim();
      if (label && placeholder && label !== placeholder) {
        var listButtons = document.querySelectorAll('#vehicle-model-list .disclosure__link');
        for (var i = 0; i < listButtons.length; i++) {
          var listBtn = listButtons[i];
          var listLabel = (listBtn.dataset.optionText || listBtn.textContent || '').trim();
          if (listLabel === label) {
            return {
              value:       listBtn.dataset.value        || '',
              label:       label,
              vehicleSize: listBtn.dataset.vehicleSize   || '',
              odooSku:     listBtn.dataset.vehicleOdooSku || '',
            };
          }
        }
        return {
          value:       toStableKey(label),
          label:       label,
          vehicleSize: '',
          odooSku:     triggerSpan.getAttribute('data-vehicle-odoo-sku') || '',
        };
      }
    }

    return null;
  }

  function readGeneration() {
    var selected = document.querySelector('#generation-list [role="radio"][aria-checked="true"]');
    if (selected) return (selected.dataset.generation || selected.textContent || '').trim();
    var input = document.querySelector('#generation-list input[type="radio"]:checked');
    if (input) return (input.value || '').trim();
    return '';
  }

  function readInstallLocation() {
    var selector = document.querySelector('install-location-selector');
    if (!selector) return null;

    var selected = selector.querySelector('.disclosure__link[aria-selected="true"]');
    var value = '';
    if (typeof selector.value === 'string' && selector.value) {
      value = selector.value;
    } else if (selected) {
      value = selected.dataset.value || (selected.textContent || '').trim();
    }
    if (!value) return null;

    return {
      value:        value,
      label:        selected ? (selected.textContent || '').trim() : value,
      handle:       selected ? (selected.dataset.handle || '') : '',
      locationName: selected ? (selected.dataset.locationName || '') : '',
      salesTaxRate: selected ? (selected.dataset.salesTaxRate || '') : '',
      shippingCents: selected ? (selected.dataset.shippingCents || '0') : '',
      shippingLabel: selected ? (selected.dataset.shippingLabel || '') : '',
    };
  }

  function readVariantId() {
    var input = document.querySelector(
      'form[data-type="add-to-cart-form"] input.product-variant-id[name="id"]'
    );
    if (input && input.value) return input.value;
    return new URLSearchParams(window.location.search).get('variant') || null;
  }

  function readAddOns() {
    return readAllAddOns()
      .filter(function (addOn) { return addOn.selected; })
      .map(function (addOn) {
        return {
          id:      addOn.id,
          title:   addOn.title,
          price:   addOn.price,
          value:   addOn.value,
          odooSku: addOn.odooSku,
        };
      });
  }

  function readAllAddOns() {
    var inputs = document.querySelectorAll(
      '.add-on-product-wrapper:not([style*="display: none"]) input.add-on-checkbox'
    );
    var addOns = [];
    inputs.forEach(function (inp) {
      addOns.push({
        id:       inp.dataset.addOnId    || '',
        title:    inp.dataset.addOnTitle || '',
        price:    parseFloat(inp.dataset.price) || 0,
        value:    inp.value || '',
        odooSku:  inp.dataset.odooSku    || '',
        selected: inp.checked,
      });
    });
    return addOns;
  }

  function toStableKey(str) {
    return String(str || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '') || 'option';
  }

  function ensureUniqueKey(key, usedKeys) {
    var base = key;
    var n = 1;
    while (usedKeys[key]) {
      key = base + '_' + n;
      n += 1;
    }
    usedKeys[key] = true;
    return key;
  }

  function readOptionsByKey() {
    var map = {};
    var usedKeys = {};

    document.querySelectorAll(
      '.product-form__input--checkbox fieldset.product-form__input--pill'
    ).forEach(function (fieldset) {
      if (fieldset.id === 'add-on-products') return;

      var label = getFieldsetLabel(fieldset) || '';
      var inputs = fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      if (!inputs.length) return;

      var firstName = parsePropertyName(inputs[0].name);
      if (firstName.indexOf('Add Ons:') === 0) return;

      var key = ensureUniqueKey(toStableKey(label || firstName), usedKeys);
      var hasCheckbox = fieldset.querySelector('input[type="checkbox"]') !== null;

      if (hasCheckbox) {
        var selections = [];
        fieldset.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          selections.push(Object.assign(selectionFromInput(input), { selected: input.checked }));
        });
        map[key] = {
          label:      label || firstName,
          name:       firstName,
          selected:   selections.some(function (s) { return s.selected; }),
          selections: selections,
        };
        return;
      }

      var checked = fieldset.querySelector('input[type="radio"]:checked');
      map[key] = {
        label:          label || firstName,
        name:           firstName,
        selected:       !!checked,
        value:          checked ? checked.value : null,
        selectionLabel: checked ? getInputDisplayLabel(checked) : null,
        price:          checked ? parseInputPrice(checked) : null,
        odooSku:        checked ? (checked.getAttribute('data-odoo-sku') || '') : '',
      };
    });

    var vs = document.querySelector('variant-selects');
    if (vs) {
      vs.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
        var label = getFieldsetLabel(fieldset) || '';
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        var key = ensureUniqueKey(
          toStableKey(label || (checked && checked.name) || 'variant_option'),
          usedKeys
        );
        map[key] = {
          label:          label,
          name:           checked ? checked.name : '',
          type:           'variant',
          selected:       !!checked,
          value:          checked ? checked.value : null,
          selectionLabel: checked ? getInputDisplayLabel(checked) : null,
          price:          checked ? parseInputPrice(checked) : null,
          odooSku:        checked ? (checked.getAttribute('data-odoo-sku') || '') : '',
        };
      });
    }

    return map;
  }

  function readAddOnsByKey() {
    var map = {};
    var usedKeys = {};

    readAllAddOns().forEach(function (addOn) {
      var baseKey = addOn.id ? String(addOn.id) : toStableKey(addOn.title);
      var key = ensureUniqueKey(baseKey, usedKeys);
      map[key] = {
        id:       addOn.id,
        title:    addOn.title,
        price:    addOn.price,
        odooSku:  addOn.odooSku,
        selected: addOn.selected,
      };
    });

    return map;
  }

  function extractPropertyKey(name) {
    var m = name && name.match(/^properties\[(.+)\]$/);
    return m ? m[1] : null;
  }

  function extractOptionKey(name) {
    var m = name && name.match(/^options\[(.+)\]$/);
    return m ? m[1] : null;
  }

  function readOptions() {
    var options = {};

    document.querySelectorAll(
      '.product-form__input--checkbox fieldset.product-form__input--pill'
    ).forEach(function (fieldset) {
      var checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        var k = extractPropertyKey(checkedRadio.name);
        if (k) options[k.trim()] = checkedRadio.value;
      }
      fieldset.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        var k = extractPropertyKey(cb.name);
        if (!k) return;
        k = k.trim();
        options[k] = Object.prototype.hasOwnProperty.call(options, k)
          ? [].concat(options[k], cb.value)
          : cb.value;
      });
    });

    var vs = document.querySelector('variant-selects');
    if (vs) {
      vs.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        var k = extractOptionKey(r.name) || r.name;
        if (k) options[k.replace(/\s+/g, ' ').trim()] = r.value;
      });
    }

    return options;
  }

  function parsePropertyName(name) {
    var m = name && name.match(/^properties\[(.+)\]$/);
    return m ? m[1] : (name || '');
  }

  function getFieldsetLabel(fieldset) {
    var legend = fieldset.querySelector('legend.form__label');
    if (!legend) return '';
    var triggerLabel = legend.querySelector('.addon-info-trigger span:first-child');
    if (triggerLabel) return (triggerLabel.textContent || '').trim();
    return (legend.textContent || '').trim();
  }

  var UNAVAILABLE_LABEL_RE = /variant sold out or unavailable|value_unavailable/i;

  function isUnavailablePlaceholder(text) {
    if (!text || !String(text).trim()) return true;
    var normalized = String(text).replace(/\s+/g, ' ').trim();
    return UNAVAILABLE_LABEL_RE.test(normalized) && normalized.length < 120;
  }

  function stripPriceFromLabel(text) {
    if (!text) return '';
    return String(text)
      .replace(/\s*\+\$[\d,]+(?:\.\d{2})?/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getInputDisplayLabel(input) {
    if (!input) return '';
    if (input.dataset.addOnTitle) return stripPriceFromLabel(input.dataset.addOnTitle);

    if (input.id) {
      var safeId = input.id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      var label = document.querySelector('label[for="' + safeId + '"]');
      if (label) {
        var wrapper = label.closest('.swatch-wrapper');
        if (wrapper) {
          var swatchLabel = wrapper.querySelector('.swatch-label');
          if (swatchLabel && swatchLabel.textContent.trim()) {
            return stripPriceFromLabel(swatchLabel.textContent.trim());
          }
        }

        var pillLeft = label.querySelector('.pill-input__title, .left');
        if (pillLeft && pillLeft.textContent.trim()) {
          return stripPriceFromLabel(pillLeft.textContent.trim());
        }

        var clone = label.cloneNode(true);
        clone.querySelectorAll('.visually-hidden, .label-unavailable').forEach(function (node) {
          node.remove();
        });
        var fromLabel = (clone.textContent || '').replace(/\s+/g, ' ').trim();
        if (fromLabel && !isUnavailablePlaceholder(fromLabel)) {
          return stripPriceFromLabel(fromLabel);
        }
      }
    }

    var fieldset = input.closest('fieldset');
    if (fieldset && input.checked) {
      var selectedSwatch = fieldset.querySelector('[data-selected-swatch-value]');
      if (selectedSwatch && selectedSwatch.textContent.trim()) {
        return stripPriceFromLabel(selectedSwatch.textContent.trim());
      }
    }

    var inputValue = (input.value || '').trim();
    if (inputValue && !isUnavailablePlaceholder(inputValue)) {
      return stripPriceFromLabel(inputValue);
    }

    return stripPriceFromLabel(inputValue);
  }

  function parseInputPrice(input) {
    if (!input) return null;
    var raw = input.getAttribute('data-price');
    if (raw !== null && raw !== '') {
      var parsed = parseFloat(String(raw).replace(/,/g, ''));
      if (!isNaN(parsed)) return parsed;
    }
    var match = (input.value || '').match(/\+?\$?([0-9,]+\.?[0-9]*)/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : null;
  }

  function selectionFromInput(input) {
    return {
      label:   getInputDisplayLabel(input),
      value:   input.value || '',
      price:   parseInputPrice(input),
      odooSku: input.getAttribute('data-odoo-sku') || '',
    };
  }

  function readOptionGroups() {
    var groups = [];

    document.querySelectorAll(
      '.product-form__input--checkbox fieldset.product-form__input--pill'
    ).forEach(function (fieldset) {
      if (fieldset.id === 'add-on-products') return;

      var checked = fieldset.querySelectorAll('input:checked');
      if (!checked.length) return;

      var first = checked[0];
      var propertyName = parsePropertyName(first.name);
      if (propertyName.indexOf('Add Ons:') === 0) return;

      var selections = [];
      checked.forEach(function (input) {
        selections.push(selectionFromInput(input));
      });

      groups.push({
        name:       propertyName,
        label:      getFieldsetLabel(fieldset) || propertyName,
        type:       first.type,
        selections: selections,
      });
    });

    var vs = document.querySelector('variant-selects');
    if (vs) {
      vs.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;

        var optionLabel = getFieldsetLabel(fieldset) || checked.name || '';
        groups.push({
          name:       checked.name || optionLabel,
          label:      optionLabel,
          type:       'variant',
          selections: [selectionFromInput(checked)],
        });
      });
    }

    return groups;
  }

  function flattenOptionGroups(groups) {
    var flat = [];
    groups.forEach(function (group) {
      (group.selections || []).forEach(function (selection) {
        flat.push({
          group:   group.label || group.name,
          name:    group.name,
          type:    group.type,
          label:   selection.label,
          value:   selection.value,
          price:   selection.price,
          odooSku: selection.odooSku,
        });
      });
    });
    return flat;
  }

  function readVariantDetails() {
    var id = readVariantId();
    if (!id) return null;

    var details = { id: String(id), title: '', sku: '', price: null };
    var vs = document.querySelector('variant-selects script[type="application/json"]');

    if (vs) {
      try {
        var variants = JSON.parse(vs.textContent);
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) {
            details.title = variants[i].title || variants[i].name || '';
            details.sku = variants[i].sku || '';
            if (variants[i].price) details.price = variants[i].price / 100;
            break;
          }
        }
      } catch (e) { /* variant JSON unavailable */ }
    }

    return details;
  }

  function parseMoneyElement(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    var match = (el.textContent || '').match(/\$?([0-9,]+\.?[0-9]*)/);
    return match ? parseFloat(match[1].replace(/,/g, '')) : null;
  }

  function readPricingSummary() {
    var base = parseMoneyElement('display-price');
    var addOnsTotal = parseMoneyElement('add-on-total');
    var requiredAddonsTotal = parseMoneyElement('required-addons-total');
    var total = parseMoneyElement('total-price');
    var installFeeEl = document.getElementById('install-fee');
    var installFeeWaivedEl = document.getElementById('install-fee-waived');
    var installFee = null;
    var installFeeWaived = false;

    if (installFeeWaivedEl && installFeeWaivedEl.style.display !== 'none') {
      installFeeWaived = true;
      installFee = 0;
    } else if (installFeeEl) {
      installFee = parseMoneyElement('install-fee');
    }

    var shipping = null;
    var shippingContainer = document.getElementById('shipping-fee-container');
    if (shippingContainer && !shippingContainer.hidden) {
      shipping = parseMoneyElement('shipping-fee');
    }

    if (base === null && addOnsTotal === null && requiredAddonsTotal === null && total === null) return null;

    return {
      base:             base,
      addOnsTotal:      addOnsTotal,
      requiredAddonsTotal: requiredAddonsTotal,
      installFee:       installFee,
      installFeeWaived: installFeeWaived,
      shipping:         shipping,
      total:            total,
      currency:         'USD',
    };
  }

  function serializeConfiguratorState() {
    var state = {
      vehicle:         readVehicle(),
      variantId:       readVariantId(),
      addOns:          readAddOns(),
      options:         readOptions(),
      installLocation: readInstallLocation(),
    };
    var generation = readGeneration();
    if (generation) state.generation = generation;
    return state;
  }

  function serializeForWebhook() {
    var settings = window.configuratorSettings || {};
    var productSettings = settings.product || {};
    var optionGroups = readOptionGroups();
    var vehicle = readVehicle();
    var variant = readVariantDetails();
    var addOnsAll = readAllAddOns();
    var generation = readGeneration() || null;

    return {
      product: {
        id:      productSettings.id ? String(productSettings.id) : '',
        title:   productSettings.title || '',
        handle:  productSettings.handle || '',
        pageUrl: window.location.origin + window.location.pathname,
      },
      vehicle:          vehicle,
      generation:       generation || null,
      installLocation:  readInstallLocation(),
      variant:          variant,
      optionGroups: optionGroups,
      options:      flattenOptionGroups(optionGroups),
      optionsByKey: readOptionsByKey(),
      addOns:       readAddOns(),
      addOnsAll:    addOnsAll,
      addOnsByKey:  readAddOnsByKey(),
      pricing:      readPricingSummary(),
    };
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function findVehicleButton(value) {
    if (!value) return null;
    var needle = String(value).trim();
    if (!needle) return null;
    var btns = document.querySelectorAll('#vehicle-model-list .disclosure__link');
    var i;
    for (i = 0; i < btns.length; i++) {
      if (btns[i].dataset.value === needle) return btns[i];
    }
    var needleKey = toStableKey(needle);
    for (i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var label = (btn.dataset.optionText || btn.textContent || '').trim();
      if (label === needle) return btn;
      if (btn.dataset.value && toStableKey(btn.dataset.value) === needleKey) return btn;
      if (label && toStableKey(label) === needleKey) return btn;
    }
    return null;
  }

  function findGenerationButton(generation) {
    if (!generation) return null;
    var radios = document.querySelectorAll('#generation-list [role="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var value = (radios[i].dataset.generation || radios[i].textContent || '').trim();
      if (value === generation) return radios[i];
    }
    return null;
  }

  function installLocationCandidates(location) {
    if (!location) return [];
    if (typeof location === 'string') return location ? [location] : [];
    return [location.handle, location.value, location.locationName, location.label]
      .map(function (part) { return String(part || '').trim(); })
      .filter(Boolean);
  }

  function findInstallLocationButton(location) {
    var candidates = installLocationCandidates(location);
    if (!candidates.length) return null;

    var btns = document.querySelectorAll('install-location-selector .disclosure__link');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var values = [
        btn.dataset.handle || '',
        btn.dataset.value || '',
        btn.dataset.locationName || '',
        (btn.textContent || '').trim(),
      ];
      for (var c = 0; c < candidates.length; c++) {
        if (values.indexOf(candidates[c]) !== -1) return btn;
      }
    }
    return null;
  }

  function restoreInstallLocation(location) {
    var btn = findInstallLocationButton(location);
    if (!btn) {
      if (location) console.warn('[Configurator] Install location not found:', location);
      return false;
    }
    var selector = btn.closest('install-location-selector');
    if (selector && typeof selector.select === 'function') {
      selector.select(btn, { silent: true });
      return true;
    }
    btn.click();
    return true;
  }

  function restoreVariantOption(optionName, value) {
    var vs = document.querySelector('variant-selects');
    if (!vs) return false;
    var radios = vs.querySelectorAll('input[type="radio"]');
    var needle = String(optionName || '').replace(/\s+/g, ' ').trim();
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var radioName = String(r.name || '').replace(/\s+/g, ' ').trim();
      if (radioName === needle && r.value === value) {
        if (!r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }

  function restorePropertyOption(optionName, values) {
    var vals     = Array.isArray(values) ? values : [values];
    var needleName = String(optionName || '').trim();
    var propName = 'properties[' + needleName + ']';
    vals.forEach(function (val) {
      var targetVal = String(val == null ? '' : val);
      var inputs = document.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var name = inp.name || '';
        var propertyKey = extractPropertyKey(name);
        var matchesName = name === propName || propertyKey === needleName;
        if (!matchesName) continue;

        var title = inp.dataset.addOnTitle || '';
        var matchesValue =
          inp.value === targetVal ||
          title === targetVal ||
          (title && stripPriceFromLabel(title) === stripPriceFromLabel(targetVal));
        if (!matchesValue) continue;

        if (!inp.checked) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
        break;
      }
    });
  }

  function restoreOptions(options) {
    if (!options || typeof options !== 'object') return;

    var vsNames = Object.create(null);
    var vs = document.querySelector('variant-selects');
    if (vs) {
      vs.querySelectorAll('input[type="radio"]').forEach(function (r) {
        if (r.name) vsNames[r.name.replace(/\s+/g, ' ').trim()] = true;
      });
    }

    Object.keys(options).forEach(function (key) {
      var value = options[key];
      if (vsNames[key]) {
        restoreVariantOption(key, String(value));
      } else {
        restorePropertyOption(key, value);
      }
    });
  }

  function mergeOptionsWithAddOns(state) {
    var options = Object.assign({}, state && state.options ? state.options : {});
    (state && state.addOns ? state.addOns : []).forEach(function (addOn) {
      if (!addOn || !addOn.title) return;
      var key = 'Add Ons: ' + addOn.title;
      if (addOn.value) options[key] = addOn.value;
    });
    return options;
  }

  function restoreAddOns(state) {
    if (!state) return;
    var options = mergeOptionsWithAddOns(state);
    document.querySelectorAll('.add-on-checkbox').forEach(function (inp) {
      var key = extractPropertyKey(inp.name);
      if (!key || key.indexOf('Add Ons:') !== 0) return;
      var shouldCheck = Object.prototype.hasOwnProperty.call(options, key) && options[key];
      if (shouldCheck) {
        if (!inp.checked) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (inp.checked) {
        var requiredWrapper = inp.closest('#add-on-products .add-on-product-wrapper');
        var requiredVisible = requiredWrapper && requiredWrapper.style.display !== 'none';
        if (requiredVisible) return;
        inp.checked = false;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  async function restoreConfiguratorState(state) {
    try {
      if (!state) return;
      isRestoring = true;

      var vehicleValue = state.vehicle && state.vehicle.value;
      if (vehicleValue) {
        var vBtn = findVehicleButton(vehicleValue);
        if (vBtn) {
          vBtn.click();
        } else {
          console.warn('[Configurator] Vehicle not found:', vehicleValue);
        }
      }

      await delay(VEHICLE_SETTLE_MS);

      if ('generation' in state && state.generation) {
        var gBtn = findGenerationButton(state.generation);
        if (gBtn) {
          gBtn.click();
        } else {
          console.warn('[Configurator] Generation not found:', state.generation);
        }
        await delay(GEN_SETTLE_MS);
      }

      restoreOptions(mergeOptionsWithAddOns(state));
      restoreAddOns(state);

      if (window.addOnProductsManager && typeof window.addOnProductsManager.applyCurrentVehicle === 'function') {
        window.addOnProductsManager.applyCurrentVehicle();
      }

      if (state.installLocation) {
        restoreInstallLocation(state.installLocation);
      }

      document.dispatchEvent(new CustomEvent('price:update'));
      isRestoring = false;
      saveState(true);
    } catch (err) {
      isRestoring = false;
      console.error('[Configurator] Restore error:', err);
    }
  }

  var saveTimer = null;

  function syncUrlFromState(state) {
    if (isRestoring) return;
    var query = buildShareQueryFromState(state);
    if (!query) return;

    var url = new URL(window.location.href);
    var cartKey = url.searchParams.get(PARAM_CART_KEY);
    var keys = [];
    url.searchParams.forEach(function (_, key) { keys.push(key); });
    keys.forEach(function (key) {
      if (key === PARAM_CART_KEY) return;
      if (key.indexOf('cfg_') === 0 || key === 'variant') url.searchParams.delete(key);
    });

    new URLSearchParams(query).forEach(function (value, key) {
      url.searchParams.append(key, value);
    });
    if (cartKey) url.searchParams.set(PARAM_CART_KEY, cartKey);

    var nextSearch = url.searchParams.toString();
    var nextHref = url.pathname + (nextSearch ? '?' + nextSearch : '');
    window.history.replaceState({}, '', nextHref);
    window.__spConfiguratorBootSearch = nextSearch ? '?' + nextSearch : '';
  }

  function saveState(force) {
    if (isRestoring && !force) return;
    var state;
    try { state = serializeConfiguratorState(); } catch (e) { return; }
    if (!state.vehicle || !state.vehicle.value) return;
    try {
      var savedAt = Date.now();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ data: state, savedAt: savedAt }));
      syncUrlFromState(state);
      document.dispatchEvent(new CustomEvent('configurator:stateSaved', { detail: { state: state } }));
    } catch (e) { /* quota or restricted context */ }
  }

  function scheduleSave() {
    if (isRestoring) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveState, SAVE_DEBOUNCE_MS);
  }

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || !entry.data || !entry.savedAt) return null;
      if (Date.now() - entry.savedAt > EXPIRY_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return entry.data;
    } catch (e) {
      return null;
    }
  }

  function clearState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* blocked */ }
  }

  function attachSaveListeners() {
    document.addEventListener('vehicleSelected', scheduleSave);
    document.addEventListener('generationSelected', scheduleSave);
    document.addEventListener('installLocationSelected', scheduleSave);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest('variant-selects') ||
          t.closest('.product-form__input') ||
          t.classList.contains('add-on-checkbox')) {
        scheduleSave();
      }
    });
  }

  function attemptSessionRestore() {
    var state = loadState();
    if (!state || !state.vehicle || !state.vehicle.value) return;
    restoreConfiguratorState(state).catch(function (err) {
      console.warn('[Configurator] Session restore failed:', err);
    });
  }

  // URL STATE + SHARE BUTTON

  function buildShareQueryFromState(state) {
    if (!state || !state.vehicle || !state.vehicle.value) return '';

    var p = new URLSearchParams();
    if (state.variantId) p.set('variant', state.variantId);
    p.set(PARAM_VEHICLE, state.vehicle.value);
    if ('generation' in state && state.generation) p.set(PARAM_GENERATION, state.generation);
    if (state.installLocation) {
      var installParam = state.installLocation.handle || state.installLocation.value;
      if (installParam) p.set(PARAM_INSTALL_LOCATION, installParam);
    }

    var options = mergeOptionsWithAddOns(state);
    Object.keys(options).forEach(function (key) {
      var v = options[key];
      if (Array.isArray(v)) {
        v.forEach(function (val) { p.append(PARAM_OPTION_PREFIX + key, val); });
      } else if (v !== null && v !== undefined && v !== '') {
        p.set(PARAM_OPTION_PREFIX + key, v);
      }
    });

    return p.toString();
  }

  function buildShareQuery() {
    try { return buildShareQueryFromState(serializeConfiguratorState()); } catch (e) { return ''; }
  }

  function buildShareUrl() {
    var q = buildShareQuery();
    if (!q) return window.location.href;
    return window.location.origin + window.location.pathname + '?' + q;
  }

  var bootSearch = window.__spConfiguratorBootSearch || window.location.search || '';

  function getSearchParams() {
    var live = new URLSearchParams(window.location.search);
    if (live.get(PARAM_VEHICLE)) return live;
    return new URLSearchParams(bootSearch);
  }

  function hasCfgParams() {
    return !!getSearchParams().get(PARAM_VEHICLE);
  }

  function parseStateFromUrl() {
    var p = getSearchParams();
    var vehicleValue = p.get(PARAM_VEHICLE);
    if (!vehicleValue) return null;

    var state = { vehicle: { value: vehicleValue }, options: {} };
    var gen = p.get(PARAM_GENERATION);
    if (gen) state.generation = gen;
    var install = p.get(PARAM_INSTALL_LOCATION);
    if (install) state.installLocation = { value: install, handle: install };

    p.forEach(function (value, key) {
      if (key.indexOf(PARAM_OPTION_PREFIX) === 0) {
        var optName  = key.slice(PARAM_OPTION_PREFIX.length);
        var existing = state.options[optName];
        state.options[optName] = existing !== undefined ? [].concat(existing, value) : value;
      }
    });

    return state;
  }

  function restoreFromUrl() {
    var state = parseStateFromUrl();
    if (!state) return;
    restoreConfiguratorState(state).catch(function (err) {
      console.warn('[Configurator] URL restore failed:', err);
    });
  }

  function normalizeStateForCompare(state) {
    if (!state) return null;
    var options = mergeOptionsWithAddOns(state);
    var keys = Object.keys(options).sort();
    var normalizedOptions = {};
    keys.forEach(function (key) { normalizedOptions[key] = options[key]; });
    return {
      vehicle: state.vehicle && state.vehicle.value,
      generation: state.generation || '',
      install: state.installLocation && (state.installLocation.handle || state.installLocation.value) || '',
      options: normalizedOptions,
    };
  }

  function stateDiffers(a, b) {
    return JSON.stringify(normalizeStateForCompare(a)) !== JSON.stringify(normalizeStateForCompare(b));
  }

  function isPageReload() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return !!(nav && nav.type === 'reload');
    } catch (e) {
      return false;
    }
  }

  function startOver() {
    clearState();
    try {
      sessionStorage.setItem('sp_cfg_unbound', '1');
    } catch (e) {}
    var url = new URL(window.location.href);
    var keys = [];
    url.searchParams.forEach(function (_, key) {
      keys.push(key);
    });
    keys.forEach(function (key) {
      if (key.indexOf('cfg_') === 0 || key === 'variant') {
        url.searchParams.delete(key);
      }
    });
    var query = url.searchParams.toString();
    window.location.href = query ? url.pathname + '?' + query : url.pathname;
  }

  // INIT

  attachSaveListeners();

  function onReady() {
    var sessionState = loadState();
    var urlState = parseStateFromUrl();

    if (sessionState && sessionState.vehicle && sessionState.vehicle.value) {
      if (hasCfgParams() && isPageReload() && stateDiffers(sessionState, urlState)) {
        restoreConfiguratorState(sessionState).catch(function (err) {
          console.warn('[Configurator] Session restore failed:', err);
        });
      } else if (hasCfgParams()) {
        restoreFromUrl();
      } else {
        attemptSessionRestore();
      }
    } else if (hasCfgParams()) {
      restoreFromUrl();
    }

    document.dispatchEvent(new CustomEvent('configurator:ready'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(onReady, 0); });
  } else {
    setTimeout(onReady, 0);
  }

  // PUBLIC API

  window.ConfiguratorSerializer = {
    serialize:             serializeConfiguratorState,
    serializeForWebhook:   serializeForWebhook,
    _readVehicle:          readVehicle,
    _readGeneration:       readGeneration,
    _readInstallLocation:  readInstallLocation,
    _readVariantId:        readVariantId,
    _readAddOns:           readAddOns,
    _readOptions:          readOptions,
    _isGenerationRequired: isGenerationRequired,
  };

  window.ConfiguratorRestore = {
    restore:               restoreConfiguratorState,
    _findVehicleButton:    findVehicleButton,
    _findGenerationButton: findGenerationButton,
    _findInstallLocationButton: findInstallLocationButton,
    _restoreInstallLocation: restoreInstallLocation,
    _restoreVariantOption: restoreVariantOption,
    _restorePropertyOption: restorePropertyOption,
    _restoreOptions:       restoreOptions,
  };

  window.ConfiguratorSession = {
    save:  saveState,
    load:  loadState,
    clear: clearState,
  };

  window.ConfiguratorUrlState = {
    buildShareQuery:   buildShareQuery,
    buildShareUrl:     buildShareUrl,
    hasCfgParams:      hasCfgParams,
    parseStateFromUrl: parseStateFromUrl,
  };

  window.ConfiguratorCart = {
    startOver: startOver,
  };

})();
